import { useEffect } from 'react';

/**
 * Hook que ejecuta `onClose` cuando se hace clic fuera de `ref` o se presiona ESC.
 *
 * @param {React.RefObject<HTMLElement>} ref - Referencia al contenedor que queremos vigilar.
 * @param {Function} onClose - Función que se ejecuta al detectar clic fuera o tecla ESC.
 */
export const useClickOutside = (ref, onClose) => {
  useEffect(() => {
    const handleClick = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [ref, onClose]);
};
